module.exports = __webpack_public_path__ + "static/media/files icon-picture.83944e59.png";